import { getWindowOrThrow } from "@faire/web--source/common/globals/getWindow";

/**
 * Wrapper around window.scrollTo that checks its availability:
 * no-op if window.scrollTo is not defined
 */
export const safeScrollTo = (options: ScrollToOptions): void => {
  if (typeof getWindowOrThrow().scrollTo !== "undefined") {
    getWindowOrThrow().scrollTo?.(options);
  }
};
